import { LicenseValidityUpdate } from './context-update';
import { LicenseKind } from './license-kind';
import { LicenseValidityChooser } from './license-validity-chooser';
import { ProductIdentifier } from './product-identifier';
import { QuantityConstraints } from './quantity-constraints';

export interface LicenseType<T = Date> {
  licenseTypeId: string;
  productIdentifier: ProductIdentifier;
  quantityConstraints: QuantityConstraints;
  quantityPreselection: number | null;
  kind: LicenseKind;
  validityUpdate: LicenseValidityUpdate<T>;
  validityChooser: LicenseValidityChooser<T> | null;
}
